// Preferred Notification Language options are displayed in their native script,
// but the backend expects the English key. These maps convert between the two.
export const NOTIFICATION_LANGUAGE_DISPLAY_TO_KEY: Record<string, string> = {
  'English': 'English',
  'دری': 'Dari',
  'پشتو': 'Pashto',
};

export const NOTIFICATION_LANGUAGE_KEY_TO_DISPLAY: Record<string, string> = {
  'English': 'English',
  'Dari': 'دری',
  'Pashto': 'پشتو',
};

// Options shown in the dropdown (native script).
export const NOTIFICATION_LANGUAGE_OPTIONS = ['English', 'دری', 'پشتو'];
